import styled from 'styled-components'

const StyledAddRunningRecord = styled.div`
  > div:first-child {
    margin-bottom: 16px;

    > label {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      color: #333d6c;
    }
  }

  p {
    color: #333d6c;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    > span,
    &.title {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
  }

  > textarea {
    width: calc(100% - 40px);
  }

  > div.checkbox-wrapper {
    display: flex;
    flex-wrap: wrap;

    margin-top: 24px;
    margin-bottom: 16px;

    > div {
      width: 169px;

      margin-left: 48px;
      margin-right: 48px;
    }
  }

  div.buttons {
    display: flex;
    justify-content: flex-end;
  }
`

export default StyledAddRunningRecord
